import type { MyBridgeAgent } from '@common/reducers/backend-api/backend-api';

const digitsOf = (id: string): string => (id || '').replace(/[^\d]/g, '');

/**
 * Does this agent answer the open chat? (#813: the in-chat "Current chat" tab.)
 * `chatDigits` = the digits of the open chat's ids (c.us / lid / g.us spellings);
 * `isGroup` = the open chat is a group.
 */
export function agentCoversChat(agent: MyBridgeAgent, chatDigits: ReadonlySet<string>, isGroup: boolean): boolean {
  if (chatDigits.size === 0) return false;
  if (isGroup && agent.chatTypes === 'private') return false;
  const has = (ids: readonly string[] | undefined) => (ids ?? []).some((id) => chatDigits.has(digitsOf(id)));
  // 'all_except': every chat but the block list (chatIds is empty then).
  if (agent.chatScope === 'all_except') return !has(agent.chatBlockList);
  return has(agent.chatIds);
}
